import React from 'react';
import { Box, Container, Typography } from '@mui/material';

function Privacy() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 120px)',
        backgroundColor: '#F5F9FF',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 700,
            color: '#1A237E',
            mb: 3,
          }}
        >
          Integritetspolicy
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 4 }}>
          Här beskriver vi hur Seglingssajten hanterar dina uppgifter och integritet.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Spårning och cookies
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Seglingssajten spårar inte användare och använder endast nödvändiga cookies som krävs för att webbplatsen ska fungera korrekt. Vi samlar inte in personuppgifter för marknadsföring eller analys utanför det som behövs för att tillhandahålla tjänsten.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Personuppgifter
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121' }}>
          Personuppgifter som lagras används endast för att tillhandahålla och förbättra tjänsten. Vi delar inte personuppgifter med tredje part.
        </Typography>
      </Container>
    </Box>
  );
}

export default Privacy;
